import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UiFormModule } from "../../shared/ui";
import { AdminVerifactuAuthorizationComponent } from "./admin-verifactu-authorization/admin-verifactu-authorization.component";
import { AdminVerifactuAuthorizationListComponent } from "./admin-verifactu-authorization/admin-verifactu-authorization-list/admin-verifactu-authorization-list.component";

@NgModule({
  declarations: [
    AdminVerifactuAuthorizationComponent,
    AdminVerifactuAuthorizationListComponent
  ],
  exports: [
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiFormModule,
    FormsModule,
  ]
})
export class AdminModule { }
